import { render, staticRenderFns } from "./SettingsDashboard.vue?vue&type=template&id=84524760&scoped=true&"
import script from "./SettingsDashboard.vue?vue&type=script&lang=js&"
export * from "./SettingsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SettingsDashboard.vue?vue&type=style&index=0&id=84524760&prod&lang=scss&scoped=true&"
import style1 from "./SettingsDashboard.vue?vue&type=style&index=1&id=84524760&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84524760",
  null
  
)

export default component.exports